import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import { logPageAccess } from './services/pageAccessLogger';
import { initAppLogger } from './services/appLogger';

function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // logPageAccess is now async, but we don't await it
    // to avoid blocking the render
    logPageAccess(location.pathname);
  }, [location.pathname]);

  return null;
}

function App() {
  useEffect(() => {
    initAppLogger();
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <PageViewTracker />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;